module.exports = __webpack_public_path__ + "static/media/columns.f061f031.svg";